import { Chip, Grid, Paper } from '@material-ui/core';
import { IconAccessCode, IconLot, IconVehicle } from 'icons';
import FormatService from 'services/formatService';
import { AccessCodeListStyle } from './style';

const AccessCodeView = ({ accessCode, vehicle }) => {
    const classes = AccessCodeListStyle()

    const assetFields = [
        {
            key: 'descriptor'
        }
    ];

    const lotFields = [
        {
            key: 'lotName',
            className: classes.lotName
            //label: 'Location Name'
        },
        {
            key: 'addressLine1',
            //label: 'Address'
        },
        {
            key: 'city',
            // label: 'City'
        },
        {
            key: 'state',
            //label: 'State'
        },
        {
            key: 'zipCode',
            //label: 'Zip Code'
        }
    ];

    const otherFields = [
        {
            key: 'pinCode',
            label: 'PIN'
        },
        {
            key: 'startDate',
            label: 'Start date',
            value: (val) => FormatService.formatDateNoConversion(val)
        },
        {
            key: 'endDate',
            label: 'End date',
            value: (val) => FormatService.formatDateNoConversion(val)
        },
        {
            key: 'startTime',
            label: 'Start time',
        },
        {
            key: 'endTime',
            label: 'End time',
        },
    ];

    const fieldGroups = [
        vehicle ? {
            fields: assetFields,
            icon: <IconVehicle className={classes.icon} />
        } : {},
        {
            fields: lotFields,
            icon: <IconLot className={classes.icon} />
        },
        {
            fields: otherFields,
            icon: <IconAccessCode className={classes.icon} />
        }];

    return (
        <Paper className={classes.accessCodeWrapper}>
            <Grid container direction="column">
                {(accessCode.isExpiring || accessCode.expired) && (
                    <Grid container justifyContent="flex-end" style={{ paddingBottom: '0.3rem' }}>
                        <Chip
                            variant="outlined"
                            size="small"
                            label={accessCode.expired ? "Expired" : "Expiring Soon"}
                            className={classes.warningChip}
                        />
                    </Grid>
                )}
                <Grid container justifyContent='space-between' alignItems='center'>
                    <Grid item xs>
                        <Grid container direction='column' spacing={2}>
                            {fieldGroups?.map((fieldGroup, idx) =>
                                <Grid className={classes.fieldGroupWrapper} item container spacing={2} alignItems='center' key={idx}>
                                    <Grid item >{fieldGroup.icon}</Grid>
                                    <Grid item direction='column'>
                                        {fieldGroup?.fields?.map((field, fidx) =>
                                            <Grid item className={field.className} key={fidx}>
                                                {!!field.label && <span className={classes.label} >{field.label}</span>}
                                                {field?.value ? field.value(accessCode?.[field.key]) : accessCode?.[field.key] ?? vehicle?.[field.key] ?? '-'}
                                            </Grid>)}
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    <Grid item className={classes.qrCode}>
                        <a target='_blank' download='qr_code' href={accessCode.qrCodeUrl}>
                            <img height='200' src={accessCode.qrCodeUrl} />
                        </a>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default AccessCodeView;